import { render } from "./BpFooter.vue?vue&type=template&id=14e3e0c7&scoped=true&ts=true"
import script from "./BpFooter.vue?vue&type=script&lang=ts"
export * from "./BpFooter.vue?vue&type=script&lang=ts"

import "./BpFooter.vue?vue&type=style&index=0&id=14e3e0c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e3e0c7"]])

export default __exports__